import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'reactApp/store';

export const isDropEnabled = createSelector(
    (state: RootState) => state.uploading,
    (uploading) => !uploading.disableDropArea
);
